<div class="p-0 d-block d-lg-none navbar navbar-expand-lg navbar-light bg-light footer">
    <div class="container">

        <div class="px-3 py-2 navbar-nav m-lg-auto w-100">
            <ul class="d-flex justify-content-between w-100 mt-lg-0">
 
                <li>
                    <a (click)="cuClicked()"  [ngClass]="{'active': activeClass}" routerLinkActive="active" class="nav-item nav-link flex-column d-flex align-items-center">
                         <span class="icon fa-fw select-all fas"></span>
                        <span class="text-box"> {{displayMenuName | localize }} </span>
                    </a>
                </li>
                <li>
                    <a class="nav-item nav-link flex-column d-flex align-items-center" routerLink="/profile"
                        routerLinkActive="active"> <span class="icon fa-fw select-all fas"></span>
                        <span class="text-box"> {{this.globals.bottomTabProfile | localize }} </span>
                        <!-- Profile -->
                    </a>
                </li>

                <li>
                    <a  class="nav-item nav-link flex-column d-flex align-items-center" routerLink="/more"
                        routerLinkActive="active"><span class="icon fa-fw select-all fas"></span>
                        <span class="text-box">{{"More" | localize }}</span>
                    </a>
                </li>
            </ul>
        </div>


    </div>
</div>